export default {
  'pages.request.loginExpired':
    'A sessão expirou. Entre novamente para continuar',
  'pages.request.accessDenied':
    'Você não tem permissão para executar esta ação',
  'pages.request.responseStatus': 'Falha na solicitação (HTTP {status})',
  'pages.request.noResponse':
    'O servidor não respondeu. Tente novamente mais tarde.',
  'pages.request.error': 'Falha na solicitação. Tente novamente mais tarde.',
  'pages.login.success': 'Login realizado com sucesso!',
  'pages.login.permissionsLoadFailed':
    'Não foi possível carregar as permissões. O catálogo de endereços pessoal foi aberto; atualize a página para tentar novamente.',
  'pages.login.permissionsRetry': 'Tentar novamente',
  'pages.login.failure': 'Falha no login, tente novamente!',
  'pages.login.username.placeholder': 'Nome de usuário',
  'pages.login.username.required': 'Por favor, informe seu nome de usuário!',
  'pages.login.password.placeholder': 'Senha',
  'pages.login.password.required': 'Por favor, informe sua senha!',
  'pages.login.rememberMe': 'Lembrar-me',
  'pages.login.forgotPassword': 'Esqueceu a senha?',
  'pages.login.forgotPasswordInfo':
    'Entre em contato com o administrador para redefinir a senha',
  'pages.login.submit': 'Entrar',
  'pages.login.back': 'Voltar',
  'pages.login.emailCheck.title': 'Verificação de E-mail',
  'pages.login.emailCheck.description':
    'Um código de 6 dígitos foi enviado para {email}',
  'pages.login.emailCheck.sent':
    'Um código de verificação foi enviado para seu e-mail',
  'pages.login.tfaCheck.title': 'Autenticação em Dois Fatores',
  'pages.login.tfaCheck.description':
    'Digite o código de 6 dígitos do seu aplicativo autenticador',
  'pages.login.verifyCode.submit': 'Verificar',
  'pages.login.verifyCode.invalid': 'Código de verificação inválido',
  'pages.login.oidc.divider': 'Ou continue com',
  'pages.login.oidc.continueWith': 'Continuar com {provider}',
  'pages.login.oidc.authFailed': 'Falha no login OIDC',
  'pages.login.passkey.login': 'Entrar com Passkey',
  'pages.login.passkey.verify': 'Verificar com Passkey',
  'pages.login.passkey.cancelled': 'Verificação de Passkey cancelada',
  'pages.login.passkey.failed': 'Falha na verificação de Passkey',
  'pages.login.passkeyCheck.title': 'Verificação de Passkey',
  'pages.login.passkeyCheck.description':
    'Use seu Passkey para concluir o login',
  'pages.devices.list': 'Lista de Dispositivos',
  'pages.devices.os': 'SO',
  'pages.devices.status': 'Status',
  'pages.devices.user': 'Usuário',
  'pages.devices.deviceGroup': 'Grupo',
  'pages.devices.note': 'Observação',
  'pages.devices.online': 'Online',
  'pages.devices.offline': 'Offline',
  'pages.devices.days': 'dias',
  'pages.devices.hours': 'horas',
  'pages.devices.minutes': 'minutos',
  'pages.devices.justNow': 'agora mesmo',
  'pages.devices.enable': 'Ativar',
  'pages.devices.disable': 'Desativar',
  'pages.devices.enableSuccess': 'Dispositivo ativado',
  'pages.devices.enableFailed': 'Falha ao ativar o dispositivo',
  'pages.devices.disableSuccess': 'Dispositivo desativado',
  'pages.devices.disableFailed': 'Falha ao desativar o dispositivo',
  'pages.devices.deleteSuccess': 'Dispositivo removido',
  'pages.devices.deleteFailed': 'Falha ao remover o dispositivo',
  'pages.devices.deleteConfirm':
    'Tem certeza de que deseja remover este dispositivo?',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Informações da Estratégia',
  'pages.devices.device': 'Dispositivo',
  'pages.devices.strategy': 'Estratégia',
  'pages.devices.info': 'Informações',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Desativado',
  'pages.devices.onlineStatus': 'Status Online',
  'pages.devices.deviceGroupSearchTip':
    'Filtrar pelo nome do grupo de dispositivos',
  'pages.devices.remove': 'Remover',
  'pages.devices.removeFromGroupSuccess': 'Dispositivo removido do grupo',
  'pages.devices.removeFromGroupFailed':
    'Falha ao remover o dispositivo do grupo',
  'pages.devices.removeFromGroupConfirm':
    'Tem certeza de que deseja remover este dispositivo do grupo?',
  'pages.devices.batchRemove': 'Remoção em Lote',
  'pages.devices.batchRemoveFromGroupSuccess':
    '{count} dispositivo(s) removido(s) do grupo com sucesso',
  'pages.devices.batchRemoveFromGroupFailed':
    'Falha ao remover dispositivos do grupo',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Tem certeza de que deseja remover os dispositivos selecionados do grupo?',
  'pages.devices.batchEnable': 'Ativar em Lote',
  'pages.devices.batchDisable': 'Desativar em Lote',
  'pages.devices.batchEnableConfirm':
    'Tem certeza de que deseja ativar os dispositivos selecionados?',
  'pages.devices.batchDisableConfirm':
    'Tem certeza de que deseja desativar os dispositivos selecionados?',
  'pages.devices.batchEnableSuccess':
    '{count} dispositivo(s) ativado(s) com sucesso',
  'pages.devices.batchEnableFailed': 'Falha ao ativar dispositivos',
  'pages.devices.batchEnablePartialFailed':
    '{success} dispositivo(s) ativado(s) com sucesso, {failed} falharam',
  'pages.devices.batchDisableSuccess':
    '{count} dispositivo(s) desativado(s) com sucesso',
  'pages.devices.batchDisableFailed': 'Falha ao desativar dispositivos',
  'pages.devices.batchDisablePartialFailed':
    '{success} dispositivo(s) desativado(s) com sucesso, {failed} falharam',
  'pages.devices.edit': 'Editar Dispositivo',
  'pages.devices.updateSuccess': 'Dispositivo atualizado',
  'pages.devices.updateFailed': 'Falha ao atualizar o dispositivo',
  'pages.devices.selectUser': 'Selecionar usuário',
  'pages.devices.selectDeviceGroup': 'Selecionar grupo de dispositivos',
  'pages.devices.selectStrategy': 'Selecionar estratégia',
  'pages.devices.connect': 'Conectar',
  'pages.devices.connectRemoteDesktop': 'Área de Trabalho Remota',
  'pages.devices.connectFileTransfer': 'Transferência de Arquivos',
  'pages.devices.connectViewCamera': 'Ver Câmera',
  'pages.devices.connectPortForward': 'Encaminhamento de Porta',
  'pages.devices.connectRdp': 'RDP',
  'pages.devices.connectTerminal': 'Terminal',
  'pages.devices.connectTerminalAdmin': 'Terminal (Admin)',
  'pages.devices.searchIdPlaceholder': 'Buscar por ID do dispositivo',
  'pages.devices.searchUserPlaceholder': 'Buscar por nome de usuário',
  'pages.devices.searchOsPlaceholder': 'Buscar por SO',
  'pages.devices.searchDeviceGroupPlaceholder':
    'Buscar por nome do grupo de dispositivos',
  'pages.addressBook.name': 'Nome',
  'pages.addressBook.note': 'Observação',
  'pages.addressBook.shared': 'Catálogos de Endereços Compartilhados',
  'pages.addressBook.create': 'Criar Catálogo de Endereços',
  'pages.addressBook.edit': 'Editar Catálogo de Endereços',
  'pages.addressBook.personal': 'Catálogo de Endereços Pessoal',
  'pages.addressBook.currentAddressBook': 'Catálogo de endereços',
  'pages.addressBook.myAddressBook': 'Meu catálogo de endereços',
  'pages.addressBook.loadFailed': 'Falha ao carregar catálogos de endereços',
  'pages.addressBook.addPeer': 'Adicionar por ID',
  'pages.addressBook.addTag': 'Adicionar Tag',
  'pages.addressBook.tagName': 'Nome da Tag',
  'pages.addressBook.tagAdded': 'Tag adicionada',
  'pages.addressBook.tagAddFailed': 'Falha ao adicionar tag',
  'pages.addressBook.tagDeleted': 'Tag removida',
  'pages.addressBook.tagDeleteFailed': 'Falha ao remover a tag',
  'pages.addressBook.deleteTagConfirm':
    'Tem certeza de que deseja remover esta tag?',
  'pages.addressBook.tagModeUnion': 'Qualquer',
  'pages.addressBook.tagModeIntersection': 'Todos',
  'pages.addressBook.importDevices': 'Importar de Dispositivos',
  'pages.addressBook.importSuccess':
    '{count} dispositivo(s) importado(s) com sucesso',
  'pages.addressBook.importPartialFailed':
    '{count} dispositivo(s) falharam na importação',
  'pages.addressBook.createSuccess': 'Catálogo de endereços criado',
  'pages.addressBook.createFailed': 'Falha ao criar o catálogo de endereços',
  'pages.addressBook.updateSuccess': 'Catálogo de endereços atualizado',
  'pages.addressBook.updateFailed':
    'Falha ao atualizar o catálogo de endereços',
  'pages.addressBook.deleteSuccess': 'Catálogo(s) de endereços removido(s)',
  'pages.addressBook.deleteFailed': 'Falha ao remover catálogo(s) de endereços',
  'pages.addressBook.deleteConfirm':
    'Tem certeza de que deseja remover este catálogo de endereços?',
  'pages.addressBook.batchDeleteConfirm':
    'Tem certeza de que deseja remover os catálogos de endereços selecionados?',
  'pages.addressBook.device': 'Dispositivo',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Tags',
  'pages.addressBook.peerAdded': 'Contato adicionado',
  'pages.addressBook.peerAddFailed': 'Falha ao adicionar contato',
  'pages.addressBook.peerDeleted': 'Contato removido',
  'pages.addressBook.peerDeleteFailed': 'Falha ao remover contato',
  'pages.addressBook.deletePeerConfirm':
    'Tem certeza de que deseja remover este contato?',
  'pages.addressBook.import': 'Importar de Dispositivos',
  'pages.deviceGroups.list': 'Grupos de Dispositivos',
  'pages.deviceGroups.name': 'Nome',
  'pages.deviceGroups.note': 'Observação',
  'pages.deviceGroups.create': 'Criar Grupo de Dispositivos',
  'pages.deviceGroups.edit': 'Editar Grupo de Dispositivos',
  'pages.deviceGroups.createSuccess': 'Grupo de dispositivos criado',
  'pages.deviceGroups.createFailed': 'Falha ao criar grupo de dispositivos',
  'pages.deviceGroups.updateSuccess': 'Grupo de dispositivos atualizado',
  'pages.deviceGroups.updateFailed': 'Falha ao atualizar grupo de dispositivos',
  'pages.deviceGroups.deleteSuccess': 'Grupo de dispositivos removido',
  'pages.deviceGroups.deleteFailed': 'Falha ao remover grupo de dispositivos',
  'pages.deviceGroups.deleteConfirm':
    'Tem certeza de que deseja remover este grupo de dispositivos?',
  'pages.deviceGroups.import': 'Importar',
  'pages.deviceGroups.importDevices': 'Importar Dispositivos',
  'pages.deviceGroups.importSuccess':
    '{count} dispositivo(s) importado(s) com sucesso',
  'pages.deviceGroups.importFailed': 'Falha ao importar dispositivos',
  'pages.deviceGroups.searchNamePlaceholder': 'Buscar por nome',
  'pages.users.list': 'Lista de Usuários',
  'pages.users.name': 'Nome',
  'pages.users.displayName': 'Nome de Exibição',
  'pages.users.email': 'E-mail',
  'pages.users.note': 'Observação',
  'pages.users.status': 'Status',
  'pages.users.create': 'Criar Usuário',
  'pages.users.createSuccess': 'Usuário criado',
  'pages.users.createFailed': 'Falha ao criar usuário',
  'pages.users.deleteSuccess': 'Usuário removido',
  'pages.users.deleteFailed': 'Falha ao remover usuário',
  'pages.users.deleteConfirm':
    'Tem certeza de que deseja remover este usuário?',
  'pages.audits.conn': 'Auditoria de Conexões',
  'pages.audits.file': 'Logs de Transferência de Arquivos',
  'pages.audits.alarm': 'Auditoria de Alarmes',
  'pages.audits.console': 'Auditoria de Console',
  'pages.audits.requestedAt': 'Solicitado em',
  'pages.audits.establishedAt': 'Estabelecido em',
  'pages.audits.closedAt': 'Encerrado em',
  'pages.audits.action': 'Ação',
  'pages.audits.time': 'Hora',
  'pages.audits.alarmType': 'Tipo de Alarme',
  'pages.audits.user': 'Usuário',
  'pages.audits.detail': 'Detalhes',
  'pages.audits.operator': 'Operador',
  'pages.audits.targetType': 'Tipo de destino',
  'pages.audits.targetId': 'ID do destino',
  'pages.audits.result': 'Resultado',
  'pages.audits.reason': 'Motivo',
  'pages.audits.unknownUser': 'Usuário desconhecido',
  'pages.audits.result.allowed': 'Permitido',
  'pages.audits.result.denied': 'Negado',
  'pages.audits.target': 'Alvo',
  'pages.audits.beforeState': 'Estado anterior',
  'pages.audits.afterState': 'Estado posterior',
  'pages.audits.type': 'Tipo',
  'pages.audits.connType.remoteDesktop': 'Área de Trabalho Remota',
  'pages.audits.connType.fileTransfer': 'Transferência de Arquivos',
  'pages.audits.connType.portTransfer': 'Redirecionamento de Porta',
  'pages.audits.connType.viewCamera': 'Visualizar Câmera',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Não Autenticado',
  'pages.audits.duration': 'Duração',
  'pages.audits.note': 'Observação',
  'pages.audits.disconnect': 'Desconectar',
  'pages.audits.connectionId': 'ID da conexão',
  'pages.audits.currentConnections': 'Conexões atuais',
  'pages.audits.disconnectSuccess': 'Solicitação de desconexão enviada',
  'pages.audits.disconnectFailed': 'Falha ao desconectar!',
  'pages.audits.disconnectConfirmTitle': 'Confirmar Operação',
  'pages.audits.disconnectConfirmTip':
    'Tem certeza de que deseja desconectar este dispositivo?',
  'pages.audits.updateSuccess': 'Atualização realizada com sucesso',
  'pages.audits.updateFailed': 'Falha na atualização, tente novamente!',
  'pages.audits.exportCSV': 'Exportar CSV',
  'pages.audits.noDataToExport': 'Nenhum dado para exportar',
  'pages.audits.exportSuccess': 'Exportação concluída com sucesso',
  'pages.audits.exportFailed': 'Falha na exportação',
  'pages.audits.exportConfirmTitle': 'Exportar CSV',
  'pages.audits.exportConfirmContent':
    'Exportar até 1000 registros. Deseja continuar?',
  'pages.audits.remote': 'Remoto',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direção',
  'pages.audits.files': 'Arquivos',
  'pages.audits.remoteTip': 'Computador ou terminal controlado remotamente',
  'pages.audits.remoteSearchTip':
    'Pesquisar por ID do dispositivo remoto (correspondência parcial)',
  'pages.audits.remotePlaceholder': 'Digite o ID do dispositivo remoto',
  'pages.audits.pathTip': 'Caminho do Dispositivo Remoto',
  'pages.audits.exportCsvTip': 'Exporte até 1000 registros por vez',
  'pages.audits.limitedTip': 'Exibir os 10 maiores arquivos por tamanho',
  'pages.audits.startTime': 'Hora de Início',
  'pages.audits.endTime': 'Hora de Término',
  'pages.audits.alarmType.ipWhitelist': 'IP Não Está na Lista Branca',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'O Mesmo IP Excedeu 30 Tentativas Sem Sucesso',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'Mais de 6 Tentativas em 1 Minuto',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'Limite de Tentativas do Prefixo IPv6 Excedido',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Login do Sistema Operacional Bloqueado por Backoff',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Limite de Concorrência de Login do Sistema Operacional Excedido',
  'pages.audits.alarmType.sessionScopeViolation':
    'Violação de Permissão de Escopo de Sessão',
  'pages.audits.alarmType.idWhitelist': 'ID Não Está na Lista Branca',
  'pages.audits.primaryAuth': 'Autenticação Primária',
  'pages.audits.primaryAuth.none': 'Nenhum',
  'pages.audits.primaryAuth.click': 'Clique',
  'pages.audits.primaryAuth.temporaryPassword': 'Senha Temporária',
  'pages.audits.primaryAuth.permanentPassword': 'Senha Permanente',
  'pages.audits.primaryAuth.switchSides': 'Trocar Lados',
  'pages.audits.twoFactor': 'Autenticação de Dois Fatores',
  'pages.audits.twoFactor.none': 'Nenhum',
  'pages.audits.twoFactor.totp': 'TOTP',
  'pages.audits.twoFactor.trustedDevice': 'Dispositivo Confiável',
  'pages.audits.searchOperatorPlaceholder': 'Buscar por operador',
  'pages.audits.searchActionPlaceholder': 'Buscar por ação',
  'pages.audits.searchTargetTypePlaceholder': 'Buscar por tipo de alvo',
  'pages.common.action': 'Ação',
  'pages.common.delete': 'Excluir',
  'pages.common.edit': 'Editar',
  'pages.common.batchDelete': 'Excluir em Lote',
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe',
  'pages.404.buttonText': 'Voltar para a Página Inicial',
  'pages.customClients.createdAt': 'Criado em',
  'pages.userGroups.list': 'Lista de Grupos de Usuários',
  'pages.userGroups.name': 'Nome do Grupo',
  'pages.userGroups.note': 'Observação',
  'pages.userGroups.userCount': 'Quantidade de Usuários',
  'pages.userGroups.create': 'Criar Grupo de Usuários',
  'pages.userGroups.edit': 'Editar Grupo de Usuários',
  'pages.userGroups.deleteConfirm':
    'Tem certeza de que deseja excluir este grupo de usuários?',
  'pages.userGroups.createSuccess': 'Grupo de usuários criado',
  'pages.userGroups.createFailed': 'Falha ao criar grupo de usuários',
  'pages.userGroups.updateSuccess': 'Grupo de usuários atualizado',
  'pages.userGroups.updateFailed': 'Falha ao atualizar grupo de usuários',
  'pages.userGroups.deleteSuccess': 'Grupo de usuários excluído',
  'pages.userGroups.deleteFailed': 'Falha ao excluir grupo de usuários',
  'pages.userGroups.loadFailed': 'Falha ao carregar grupos de usuários',
  'pages.userGroups.default': 'Padrão',
  'pages.userGroups.destination': 'Grupo de destino',
  'pages.userGroups.selectDestination': 'Selecione o grupo de destino',
  'pages.userGroups.move': 'Mover',
  'pages.userGroups.batchMove': 'Mover em lote',
  'pages.userGroups.moveToGroup': 'Mover para grupo',
  'pages.userGroups.import': 'Importar',
  'pages.userGroups.importUsers': 'Importar Usuários',
  'pages.userGroups.importSuccess':
    '{count} usuário(s) importado(s) com sucesso',
  'pages.userGroups.importFailed': 'Falha ao importar usuários',
  'pages.userGroups.membersUpdated': '{count} usuário(s) atualizado(s)',
  'pages.userGroups.membersUpdateFailed': 'Falha ao atualizar membros do grupo',
  'pages.userGroups.members': 'Membros',
  'pages.userGroups.moveSelected': 'Mover selecionados',
  'pages.userGroups.addSelected': 'Adicionar usuários selecionados',
  'pages.userGroups.membersTitle': 'Membros de {name}',
  'pages.userGroups.currentMembers': 'Membros atuais',
  'pages.userGroups.addUsers': 'Adicionar usuários',
  'pages.users.userGroup': 'Grupo de Usuários',
  'pages.users.selectUserGroup': 'Selecione o grupo de usuários',
  'pages.addressBook.userGroup': 'Grupo de usuários',
  'pages.addressBook.permission': 'Permissão',
  'pages.addressBook.permissionRead': 'Somente leitura',
  'pages.addressBook.permissionReadWrite': 'Leitura e escrita',
  'pages.addressBook.permissionFull': 'Controle total',
  'pages.addressBook.shareAccess': 'Compartilhar',
  'pages.addressBook.accessTitle': '{name} - Gerenciamento de acesso',
  'pages.addressBook.accessReadOnlyTitle':
    'Configurações de compartilhamento de {name}',
  'pages.addressBook.viewShareSettings': 'Configurações de compartilhamento',
  'pages.addressBook.shareType': 'Tipo de compartilhamento',
  'pages.addressBook.shareTarget': 'Destino',
  'pages.addressBook.shareTypeEveryone': 'Todos',
  'pages.addressBook.shareTypeUser': 'Usuário',
  'pages.addressBook.shareTypeGroup': 'Grupo de usuários',
  'pages.addressBook.selectUser': 'Selecionar usuário',
  'pages.addressBook.selectUserPlaceholder':
    'Pesquisar por nome de usuário ou e-mail',
  'pages.addressBook.everyoneHint':
    'Todos os usuários terão acesso a este catálogo de endereços',
  'pages.addressBook.allUsers': 'Todos os usuários',
  'pages.addressBook.addAccess': 'Adicionar acesso',
  'pages.addressBook.accessLoadFailed': 'Falha ao carregar regras de acesso',
  'pages.addressBook.accessAdded': 'Regra de acesso adicionada',
  'pages.addressBook.accessAddFailed': 'Falha ao adicionar regra de acesso',
  'pages.addressBook.accessUpdated': 'Regra de acesso atualizada',
  'pages.addressBook.accessUpdateFailed': 'Falha ao atualizar regra de acesso',
  'pages.addressBook.accessDeleted': 'Regra de acesso excluída',
  'pages.addressBook.accessDeleteFailed': 'Falha ao excluir regra de acesso',
  'pages.addressBook.accessDeleteConfirm': 'Excluir esta regra de acesso?',
  'pages.roles.list': 'Lista de Funções',
  'pages.roles.name': 'Nome da Função',
  'pages.roles.note': 'Observação',
  'pages.roles.permissions': 'Permissões',
  'pages.roles.permissionsInfo': 'Número de permissões e recursos efetivos',
  'pages.roles.superAdminInfo':
    'O acesso de superadministrador é protegido separadamente e não pode ser concedido por uma função.',
  'pages.roles.permissionsLoadFailed':
    'Falha ao carregar o catálogo de permissões',
  'pages.roles.detailLoadFailed': 'Falha ao carregar os detalhes da função',
  'pages.roles.permissionScopeInfo':
    'As ações de dispositivo podem ser atribuídas globalmente ou a grupos de dispositivos selecionados quando um usuário recebe esta função.',
  'pages.roles.personalAddressBook': 'Catálogo de endereços pessoal',
  'pages.roles.basicFunction': 'Funcionalidade básica',
  'pages.roles.permissionPresets': 'Predefinições de permissões',
  'pages.roles.preset.custom': 'Personalizado',
  'pages.roles.preset.readOnly': 'Somente leitura global',
  'pages.roles.preset.deviceOperator': 'Operador de dispositivos',
  'pages.roles.preset.userAdministrator': 'Administrador de usuários',
  'pages.roles.preset.sharedAddressBookAdministrator':
    'Administrador de catálogos compartilhados',
  'pages.roles.preset.strategyMaintainer': 'Responsável por estratégias',
  'pages.roles.preset.deviceStrategyAssigner':
    'Atribuidor de estratégias a dispositivos',
  'pages.roles.preset.systemAdministrator': 'Administrador do sistema',
  'pages.roles.protectedAccount': 'Contas protegidas',
  'pages.roles.protectedAccountInfo':
    'Somente o superadministrador pode gerenciar contas protegidas.',
  'pages.roles.ownerOnly': 'Somente superadministrador',
  'pages.roles.systemIdentity.ordinary': 'Usuário comum',
  'pages.roles.systemIdentity.superAdmin': 'Superadministrador',
  'pages.roles.systemIdentity.builtIn': 'Integrado ao sistema',
  'pages.roles.systemIdentity.ordinarySummary':
    'Somente a funcionalidade básica da agenda pessoal.',
  'pages.roles.systemIdentity.superAdminSummary':
    'Autoridade efetiva completa do único proprietário do sistema.',
  'pages.roles.systemIdentity.systemCapabilities':
    'Definição de funções, configurações do sistema, estrutura de grupos de dispositivos e administração de identidades',
  'pages.roles.disableProtectionConfirm': 'Desativar a proteção desta função?',
  'pages.roles.disableProtectionAffected':
    '{count} membros poderão ser gerenciados por administradores delegados.',
  'pages.roles.resource.servers': 'Servidores',
  'pages.roles.permission.servers.view': 'Visualizar servidores',
  'pages.roles.permission.servers.control': 'Controlar serviços dos servidores',
  'pages.roles.permission.servers.config': 'Configurar servidores',
  'pages.roles.permission.servers.disconnect':
    'Desconectar sessões de retransmissão',
  'pages.roles.permission.servers.ban': 'Gerenciar bloqueios dos servidores',
  'pages.roles.resource.users': 'Usuários',
  'pages.roles.resource.user_groups': 'Grupos de usuários',
  'pages.roles.resource.devices': 'Dispositivos',
  'pages.roles.resource.address_books': 'Catálogos de endereços',
  'pages.roles.resource.strategies': 'Estratégias',
  'pages.roles.resource.audit': 'Auditoria',
  'pages.roles.resource.roles': 'Funções',
  'pages.roles.resource.system': 'Recursos do sistema',
  'pages.roles.resource.other': 'Outros',
  'pages.roles.unknownResource': 'Recurso desconhecido',
  'pages.roles.unknownPermission': 'Permissão desconhecida',
  'pages.roles.permission.users.view': 'Visualizar usuários',
  'pages.roles.permission.users.create': 'Criar usuários',
  'pages.roles.permission.users.edit': 'Editar usuários',
  'pages.roles.permission.users.status': 'Alterar status do usuário',
  'pages.roles.permission.users.delete': 'Excluir usuários',
  'pages.roles.permission.users.security': 'Gerenciar segurança do usuário',
  'pages.roles.permission.users.force_logout': 'Encerrar sessões de usuários',
  'pages.roles.permission.user_groups.view': 'Visualizar grupos de usuários',
  'pages.roles.permission.user_groups.create': 'Criar grupos de usuários',
  'pages.roles.permission.user_groups.edit': 'Editar grupos de usuários',
  'pages.roles.permission.user_groups.delete': 'Excluir grupos de usuários',
  'pages.roles.permission.user_groups.membership':
    'Gerenciar membros dos grupos de usuários',
  'pages.roles.permission.devices.view': 'Visualizar dispositivos',
  'pages.roles.permission.devices.edit': 'Editar detalhes dos dispositivos',
  'pages.roles.permission.devices.status': 'Alterar status dos dispositivos',
  'pages.roles.permission.devices.delete': 'Excluir dispositivos',
  'pages.roles.permission.devices.disconnect': 'Desconectar dispositivos',
  'pages.roles.permission.address_books.view':
    'Visualizar configurações de catálogos de endereços compartilhados',
  'pages.roles.permission.address_books.edit':
    'Editar catálogos de endereços compartilhados',
  'pages.roles.permission.address_books.share':
    'Criar e gerenciar catálogos de endereços compartilhados',
  'pages.roles.permission.strategies.view': 'Visualizar estratégias',
  'pages.roles.permission.strategies.create': 'Criar estratégias',
  'pages.roles.permission.strategies.edit': 'Editar estratégias',
  'pages.roles.permission.strategies.delete': 'Excluir estratégias',
  'pages.roles.permission.strategies.assign': 'Atribuir estratégias',
  'pages.roles.permission.audit.view': 'Visualizar logs de auditoria',
  'pages.roles.permission.roles.view': 'Visualizar funções',
  'pages.roles.permission.roles.assign': 'Atribuir funções',
  'pages.roles.permission.roles.create': 'Criar funções',
  'pages.roles.permission.roles.edit': 'Editar funções',
  'pages.roles.permission.roles.delete': 'Excluir funções',
  'pages.roles.create': 'Criar Função',
  'pages.roles.view': 'Ver função',
  'pages.roles.edit': 'Editar Função',
  'pages.roles.deleteConfirm': 'Tem certeza de que deseja excluir esta função?',
  'pages.roles.selectPermissions': 'Selecionar Permissões',
  'pages.roles.createSuccess': 'Função criada com sucesso',
  'pages.roles.createFailed': 'Falha ao criar função',
  'pages.roles.updateSuccess': 'Função atualizada com sucesso',
  'pages.roles.updateFailed': 'Falha ao atualizar função',
  'pages.roles.deleteSuccess': 'Função excluída com sucesso',
  'pages.roles.deleteFailed': 'Falha ao excluir função',
  'pages.roles.searchNamePlaceholder': 'Buscar por nome do papel',
  'pages.roles.searchNotePlaceholder': 'Buscar por observação',
  'pages.settings.save': 'Salvar Configurações',
  'pages.settings.general': 'Configurações Gerais',
  'pages.settings.fetchFailed': 'Falha ao carregar configurações',
  'pages.settings.saveSuccess': 'Configurações salvas com sucesso',
  'pages.settings.saveFailed': 'Falha ao salvar configurações',
  'pages.settings.generalSection.watermark': "Marca d'água do usuário",
  'pages.settings.generalSection.watermarkExtra':
    'Sobrepõe o nome de usuário atual em cada página para responsabilidade.',
  'pages.settings.generalSection.language': 'Idioma Padrão',
  'pages.settings.generalSection.languageExtra':
    'Idioma padrão da interface para novos visitantes. Usuários autenticados mantêm sua própria preferência.',
  'pages.settings.generalSection.languagePlaceholder':
    'Selecione o idioma padrão',
  'pages.settings.generalSection.site': 'Site',
  'pages.settings.generalSection.frontendUrl': 'URL do Frontend',
  'pages.settings.generalSection.frontendUrlPlaceholder':
    'https://console.example.com',
  'pages.settings.generalSection.backendUrl': 'URL do Backend',
  'pages.settings.generalSection.backendUrlExtra':
    'Deixe em branco para usar a mesma origem do frontend.',
  'pages.settings.generalSection.backendUrlPlaceholder':
    'https://api.example.com',
  'pages.settings.generalSection.urlInvalid': 'Informe uma URL válida',
  'pages.settings.generalSection.webauthn': 'WebAuthn / Passkeys',
  'pages.settings.generalSection.webauthnEnabled': 'Ativar WebAuthn',
  'pages.settings.generalSection.webauthnEnabledExtra':
    'Permite que usuários se registrem e entrem com passkeys.',
  'pages.settings.generalSection.webauthnUnsupported':
    'Este navegador não suporta WebAuthn. O login por passkey ficará indisponível para usuários em clientes sem suporte.',
  'pages.settings.generalSection.rpName': 'Nome da Parte Confiável',
  'pages.settings.generalSection.rpNameExtra':
    'Nome amigável exibido no prompt de passkey.',
  'pages.settings.generalSection.rpNamePlaceholder': 'RustDesk Console',
  'pages.settings.generalSection.security': 'Segurança e Manutenção',
  'pages.settings.generalSection.jwtExpiryDays':
    'Expiração do Token JWT (Dias)',
  'pages.settings.generalSection.jwtExpiryDaysExtra':
    'Número de dias antes que os tokens de usuários expirem. Deve ser pelo menos 1.',
  'pages.settings.generalSection.jwtExpiryDaysRequired':
    'Informe um número inteiro positivo',
  'pages.settings.generalSection.auditRetentionDays':
    'Retenção de Logs de Auditoria (Dias)',
  'pages.settings.generalSection.auditRetentionDaysExtra':
    'Número de dias para manter os logs de auditoria antes da limpeza automática. Defina como 0 para desativar.',
  'pages.settings.generalSection.auditRetentionDaysRequired':
    'Informe um número inteiro não negativo',
  'pages.strategies.list': 'Lista de Estratégias',
  'pages.strategies.name': 'Nome da Estratégia',
  'pages.strategies.note': 'Observação',
  'pages.strategies.create': 'Criar Estratégia',
  'pages.strategies.edit': 'Editar Estratégia',
  'pages.strategies.view': 'Visualizar Estratégia',
  'pages.strategies.deleteConfirm':
    'Tem certeza de que deseja excluir esta estratégia?',
  'pages.strategies.createSuccess': 'Estratégia criada',
  'pages.strategies.createFailed': 'Falha ao criar estratégia',
  'pages.strategies.updateSuccess': 'Estratégia atualizada',
  'pages.strategies.updateFailed': 'Falha ao atualizar estratégia',
  'pages.strategies.deleteSuccess': 'Estratégia removida',
  'pages.strategies.deleteFailed': 'Falha ao remover estratégia',
  'pages.strategies.enterName': 'Digite o nome da estratégia',
  'pages.strategies.configOptions': 'Opções de Configuração',
  'pages.strategies.defaultLabel': 'Padrão',
  'pages.strategies.defaultValue': 'Padrão: {value}',
  'pages.strategies.resetToDefault': 'Restaurar padrão',
  'pages.strategies.modifiedSummary': '{count} configuração(ões) modificada(s)',
  'pages.strategies.resetAll': 'Restaurar Tudo',
  'pages.strategies.assign': 'Atribuir',
  'pages.strategies.assignManagement': 'Gerenciamento de Atribuições',
  'pages.strategies.loadAssignedFailed':
    'Falha ao carregar os destinos atribuídos',
  'pages.strategies.loadTargetsFailed': 'Falha ao carregar os destinos',
  'pages.strategies.assignDevice': 'Dispositivo',
  'pages.strategies.assignUser': 'Usuário',
  'pages.strategies.assignDeviceGroup': 'Grupo de Dispositivos',
  'pages.strategies.assignedTargets': 'Destinos Atribuídos',
  'pages.strategies.noAssigned': 'Nenhum destino atribuído',
  'pages.strategies.addAssignment': 'Adicionar Atribuição',
  'pages.strategies.selectTarget': 'Selecionar destino',
  'pages.strategies.assignSuccess': 'Estratégia atribuída com sucesso',
  'pages.strategies.assignFailed': 'Falha ao atribuir estratégia',
  'pages.strategies.assignPartialFailed':
    '{success} destino(s) atribuído(s), {failed} falharam: {errors}',
  'pages.strategies.unassignSuccess': 'Estratégia removida com sucesso',
  'pages.strategies.unassignFailed':
    'Falha ao remover atribuição da estratégia',
  'pages.strategies.unassignConfirm': 'Remover atribuição deste destino?',
  'pages.strategies.fetchDetailFailed': 'Falha ao obter detalhes da estratégia',
  'pages.strategies.updatedAt': 'Atualizado em',
  'pages.strategies.category.connection': 'Conexão e Acesso',
  'pages.strategies.category.security': 'Segurança e Autenticação',
  'pages.strategies.category.display': 'Tela e Interface',
  'pages.strategies.category.av': 'Áudio, Vídeo e Codec',
  'pages.strategies.category.file': 'Arquivos e Área de Transferência',
  'pages.strategies.category.advanced': 'Avançado',
  'pages.strategies.category.floating': 'Janela Flutuante',
  'pages.strategies.category.privacy': 'Privacidade e Gravação',
  'pages.strategies.values.yes': 'Sim',
  'pages.strategies.values.no': 'Não',
  'pages.strategies.option.access-mode.label': 'Modo de Acesso',
  'pages.strategies.option.enable-keyboard.label': 'Ativar Teclado e Mouse',
  'pages.strategies.option.enable-clipboard.label':
    'Ativar Área de Transferência',
  'pages.strategies.option.enable-file-transfer.label':
    'Ativar Transferência de Arquivos',
  'pages.strategies.option.enable-camera.label': 'Ativar Câmera',
  'pages.strategies.option.enable-terminal.label': 'Ativar Terminal',
  'pages.strategies.option.enable-remote-printer.label':
    'Ativar Impressora Remota',
  'pages.strategies.option.enable-tunnel.label': 'Ativar Túnel',
  'pages.strategies.option.enable-remote-restart.label':
    'Ativar Reinicialização Remota',
  'pages.strategies.option.enable-block-input.label': 'Bloquear Entrada',
  'pages.strategies.option.allow-auto-disconnect.label':
    'Permitir Desconexão Automática',
  'pages.strategies.option.auto-disconnect-timeout.label':
    'Tempo para Desconexão Automática',
  'pages.strategies.option.allow-only-conn-window-open.label':
    'Permitir Apenas a Janela de Conexão Aberta',
  'pages.strategies.option.view-only.label': 'Somente Visualização',
  'pages.strategies.option.terminal-persistent.label': 'Terminal Persistente',
  'pages.strategies.option.allow-ask-for-note.label':
    'Solicitar Observação da Conexão',
  'pages.strategies.option.allow-remote-config-modification.label':
    'Permitir Modificação Remota da Configuração',
  'pages.strategies.option.whitelist.label': 'Lista de IPs Permitidos',
  'pages.strategies.option.approve-mode.label': 'Modo de Aprovação',
  'pages.strategies.option.verification-method.label': 'Método de Verificação',
  'pages.strategies.option.temporary-password-length.label':
    'Tamanho da Senha Temporária',
  'pages.strategies.option.lock-after-session-end.label':
    'Bloquear Após o Fim da Sessão',
  'pages.strategies.option.allow-remote-cm-modification.label':
    'Permitir Modificação Remota do Cliente',
  'pages.strategies.option.enable-trusted-devices.label':
    'Ativar Dispositivos Confiáveis',
  'pages.strategies.option.allow-numeric-one-time-password.label':
    'Permitir Senha Numérica de Uso Único',
  'pages.strategies.option.allow-insecure-tls-fallback.label':
    'Permitir Fallback TLS Inseguro',
  'pages.strategies.option.theme.label': 'Tema',
  'pages.strategies.option.lang.label': 'Idioma',
  'pages.strategies.option.enable-confirm-closing-tabs.label':
    'Confirmar Fechamento de Abas',
  'pages.strategies.option.allow-remove-wallpaper.label':
    'Permitir Remover Papel de Parede',
  'pages.strategies.option.enable-open-new-connections-in-tabs.label':
    'Abrir Novas Conexões em Abas',
  'pages.strategies.option.peer-card-ui-type.label':
    'Tipo de Cartão do Dispositivo',
  'pages.strategies.option.peer-sorting.label': 'Ordenação de Dispositivos',
  'pages.strategies.option.show-monitors-toolbar.label':
    'Mostrar Barra de Monitores',
  'pages.strategies.option.collapse-toolbar.label':
    'Recolher Barra de Ferramentas',
  'pages.strategies.option.show-remote-cursor.label': 'Mostrar Cursor Remoto',
  'pages.strategies.option.follow-remote-cursor.label': 'Seguir Cursor Remoto',
  'pages.strategies.option.follow-remote-window.label': 'Seguir Janela Remota',
  'pages.strategies.option.zoom-cursor.label': 'Ampliar Cursor',
  'pages.strategies.option.show-quality-monitor.label':
    'Mostrar Monitor de Qualidade',
  'pages.strategies.option.reverse-mouse-wheel.label': 'Inverter Roda do Mouse',
  'pages.strategies.option.swap-left-right-mouse.label':
    'Trocar Botões Esquerdo e Direito',
  'pages.strategies.option.displays-as-individual-windows.label':
    'Exibir Monitores como Janelas Individuais',
  'pages.strategies.option.use-all-my-displays-for-the-remote-session.label':
    'Usar Todos os Monitores na Sessão Remota',
  'pages.strategies.option.view-style.label': 'Estilo de Visualização',
  'pages.strategies.option.scroll-style.label': 'Estilo de Rolagem',
  'pages.strategies.option.edge-scroll-edge-thickness.label':
    'Espessura da Rolagem de Borda',
  'pages.strategies.option.trackpad-speed.label': 'Velocidade do Trackpad',
  'pages.strategies.option.disable-group-panel.label':
    'Desativar Painel de Grupos',
  'pages.strategies.option.keep-screen-on.label': 'Manter Tela Ligada',
  'pages.strategies.option.disable-discovery-panel.label':
    'Desativar Painel de Descoberta',
  'pages.strategies.option.touch-mode.label': 'Modo de Toque',
  'pages.strategies.option.show-virtual-mouse.label': 'Mostrar Mouse Virtual',
  'pages.strategies.option.show-virtual-joystick.label':
    'Mostrar Joystick Virtual',
  'pages.strategies.option.enable-audio.label': 'Ativar Áudio',
  'pages.strategies.option.allow-always-software-render.label':
    'Usar Sempre Renderização por Software',
  'pages.strategies.option.enable-hwcodec.label': 'Ativar Codec de Hardware',
  'pages.strategies.option.use-texture-render.label':
    'Usar Renderização por Textura',
  'pages.strategies.option.disable-audio.label': 'Desativar Áudio',
  'pages.strategies.option.i444.label': 'Formato de Cor I444',
  'pages.strategies.option.image-quality.label': 'Qualidade da Imagem',
  'pages.strategies.option.custom-image-quality.label':
    'Qualidade de Imagem Personalizada',
  'pages.strategies.option.custom-fps.label': 'FPS Personalizado',
  'pages.strategies.option.enable-directx-capture.label':
    'Ativar Captura DirectX',
  'pages.strategies.option.enable-android-software-encoding-half-scale.label':
    'Ativar Codificação de Software Android em Meia Escala',
  'pages.strategies.option.allow-d3d-render.label': 'Permitir Renderização D3D',
  'pages.strategies.option.enable-file-copy-paste.label':
    'Ativar Cópia e Colagem de Arquivos',
  'pages.strategies.option.disable-clipboard.label':
    'Desativar Área de Transferência',
  'pages.strategies.option.sync-init-clipboard.label':
    'Sincronizar Área de Transferência Inicial',
  'pages.strategies.option.enable-lan-discovery.label':
    'Ativar Descoberta na LAN',
  'pages.strategies.option.direct-server.label': 'Servidor Direto',
  'pages.strategies.option.allow-auto-update.label':
    'Permitir Atualizações Automáticas',
  'pages.strategies.option.enable-abr.label': 'Ativar Bitrate Adaptativo',
  'pages.strategies.option.allow-linux-headless.label':
    'Permitir Modo Headless no Linux',
  'pages.strategies.option.sync-ab-with-recent-sessions.label':
    'Sincronizar Catálogo de Endereços com Sessões Recentes',
  'pages.strategies.option.sync-ab-tags.label':
    'Sincronizar Tags do Catálogo de Endereços',
  'pages.strategies.option.filter-ab-by-intersection.label':
    'Filtrar Catálogo de Endereços por Interseção',
  'pages.strategies.option.enable-udp-punch.label': 'Ativar UDP Hole Punching',
  'pages.strategies.option.enable-ipv6-punch.label':
    'Ativar IPv6 Hole Punching',
  'pages.strategies.option.pre-elevate-service.label': 'Pré-Elevar Serviço',
  'pages.strategies.option.keep-awake-during-incoming-sessions.label':
    'Manter Ativo Durante Sessões de Entrada',
  'pages.strategies.option.keep-awake-during-outgoing-sessions.label':
    'Manter Ativo Durante Sessões de Saída',
  'pages.strategies.option.disable-udp.label': 'Desativar UDP',
  'pages.strategies.option.allow-websocket.label': 'Permitir WebSocket',
  'pages.strategies.option.disable-floating-window.label':
    'Desativar Janela Flutuante',
  'pages.strategies.option.floating-window-size.label':
    'Tamanho da Janela Flutuante',
  'pages.strategies.option.floating-window-untouchable.label':
    'Janela Flutuante Intocável',
  'pages.strategies.option.floating-window-transparency.label':
    'Transparência da Janela Flutuante',
  'pages.strategies.option.enable-record-session.label':
    'Ativar Gravação de Sessão',
  'pages.strategies.option.allow-auto-record-incoming.label':
    'Permitir Gravação Automática de Sessões de Entrada',
  'pages.strategies.option.allow-auto-record-outgoing.label':
    'Permitir Gravação Automática de Sessões de Saída',
  'pages.strategies.option.privacy-mode.label': 'Modo de Privacidade',
  'pages.strategies.option.auto-disconnect-timeout.description':
    'Tempo limite em minutos',
  'pages.strategies.option.lang.description': 'Código do idioma',
  'pages.strategies.option.enable-ipv6-punch.description':
    'Auto-hospedado: Não, outros: Sim',
  'pages.strategies.option.use-texture-render.description':
    'Depende da plataforma',
  'pages.strategies.option.whitelist.description':
    'Lista de IPs separada por vírgulas',
  'pages.strategies.option.image-quality.value.best': 'Melhor',
  'pages.strategies.option.image-quality.value.balanced': 'Balanceado',
  'pages.strategies.option.image-quality.value.low': 'Baixa',
  'pages.strategies.option.image-quality.value.custom': 'Personalizado',
  'pages.strategies.option.access-mode.value.custom': 'Personalizado',
  'pages.strategies.option.access-mode.value.full': 'Acesso Total',
  'pages.strategies.option.access-mode.value.view': 'Somente Visualização',
  'pages.strategies.option.theme.value.dark': 'Escuro',
  'pages.strategies.option.theme.value.light': 'Claro',
  'pages.strategies.option.theme.value.system': 'Sistema',
  'pages.strategies.option.peer-card-ui-type.value.0': 'Estilo de Cartão 0',
  'pages.strategies.option.peer-card-ui-type.value.1': 'Estilo de Cartão 1',
  'pages.strategies.option.peer-card-ui-type.value.2': 'Estilo de Cartão 2',
  'pages.strategies.option.peer-sorting.value.remote-id': 'ID Remoto',
  'pages.strategies.option.peer-sorting.value.remote-host': 'Host Remoto',
  'pages.strategies.option.peer-sorting.value.username': 'Nome de Usuário',
  'pages.strategies.option.view-style.value.original': 'Original',
  'pages.strategies.option.view-style.value.adaptive': 'Adaptável',
  'pages.strategies.option.scroll-style.value.scrollauto': 'Automático',
  'pages.strategies.option.scroll-style.value.scrollbar': 'Barra de Rolagem',
  'pages.strategies.option.scroll-style.value.scrolledge':
    'Rolagem pelas Bordas',
  'pages.strategies.option.keep-screen-on.value.never': 'Nunca',
  'pages.strategies.option.keep-screen-on.value.during-controlled':
    'Durante a Sessão Controlada',
  'pages.strategies.option.keep-screen-on.value.service-on': 'Serviço Ativo',
  'pages.strategies.option.approve-mode.value.password': 'Senha',
  'pages.strategies.option.approve-mode.value.click': 'Clique',
  'pages.strategies.option.approve-mode.value.password-click': 'Senha e Clique',
  'pages.strategies.option.verification-method.value.use-temporary-password':
    'Senha Temporária',
  'pages.strategies.option.verification-method.value.use-permanent-password':
    'Senha Permanente',
  'pages.strategies.option.verification-method.value.use-both-passwords':
    'Ambas as Senhas',
  'pages.strategies.option.temporary-password-length.value.6': '6 dígitos',
  'pages.strategies.option.temporary-password-length.value.8': '8 dígitos',
  'pages.strategies.option.temporary-password-length.value.10': '10 dígitos',
  'pages.strategies.searchNamePlaceholder': 'Buscar por nome da estratégia',
  'pages.users.inviteSuccess': 'Convite enviado',
  'pages.users.inviteFailed': 'Falha ao enviar convite',
  'pages.users.active': 'Ativo',
  'pages.users.disabled': 'Desativado',
  'pages.users.unverified': 'Não Verificado',
  'pages.users.roles': 'Funções',
  'pages.users.rolesTitle': 'Funções de {name}',
  'pages.users.rolesLoadFailed': 'Falha ao carregar as funções do usuário',
  'pages.users.rolesSaveFailed': 'Falha ao salvar as funções do usuário',
  'pages.users.rolesSaved': 'Funções do usuário salvas',
  'pages.users.addRole': 'Adicionar função',
  'pages.users.superAdmin': 'Superadministrador',
  'pages.users.roleAssignmentTitle': 'Função {number}',
  'pages.users.selectRole': 'Selecionar função',
  'pages.users.removeRole': 'Remover função',
  'pages.users.roleRequired': 'Selecione uma função para cada atribuição',
  'pages.users.duplicateRole': 'Cada função só pode ser atribuída uma vez',
  'pages.users.scopeMode': 'Modo de escopo da função',
  'pages.users.globalScope': 'Global',
  'pages.users.deviceGroupScope': 'Grupos de dispositivos selecionados',
  'pages.users.selectDeviceGroups':
    'Selecione um ou mais grupos de dispositivos',
  'pages.users.unsupportedDeviceGroupScope':
    'O escopo por grupo de dispositivos está disponível apenas para funções com ações de dispositivo e atribuição de estratégia',
  'pages.users.deviceGroupScopeRequired':
    'Selecione pelo menos um grupo de dispositivos',
  'pages.users.rolesScopeInfo':
    'Concessões globais prevalecem sobre concessões mais restritas por grupo de dispositivos.',
  'pages.users.protectedAccount': 'Conta protegida',
  'pages.users.protectedAccountInfo':
    'Contas protegidas só podem ser gerenciadas pelo superadministrador.',
  'pages.users.systemOwnerStatusBlocked':
    'O proprietário do sistema não pode ser ativado nem desativado.',
  'pages.users.systemOwnerMutationBlocked':
    'O proprietário do sistema não pode ser desativado nem excluído.',
  'pages.users.systemCapabilities': 'Capacidades do sistema',
  'pages.users.systemCapability.roles.create': 'Criar definições de função',
  'pages.users.systemCapability.roles.edit': 'Editar definições de função',
  'pages.users.systemCapability.roles.delete': 'Excluir definições de função',
  'pages.users.systemCapability.settings.manage':
    'Gerenciar configurações do sistema',
  'pages.users.systemCapability.device_groups.manage':
    'Gerenciar estrutura de grupos de dispositivos',
  'pages.users.systemCapability.identity_sources.manage':
    'Gerenciar fontes de identidade',
  'pages.users.roleEligibility.assign_not_allowed':
    'Você não pode atribuir esta função',
  'pages.users.roleEligibility.remove_not_allowed':
    'Você não pode remover esta função',
  'pages.users.roleEligibility.protected_role':
    'Funções protegidas só podem ser atribuídas ou removidas pelo superadministrador',
  'pages.users.roleEligibility.protected_target':
    'A conta de destino está protegida',
  'pages.users.roleEligibility.super_admin_target':
    'Funções comuns não podem ser atribuídas ao superadministrador',
  'pages.users.roleEligibility.self_target':
    'Você não pode alterar suas próprias funções',
  'pages.users.roleEligibility.missing_caller_scope':
    'O escopo de permissão é insuficiente',
  'pages.users.roleEligibility.scope_exceeds_caller':
    'O escopo da função excede suas permissões',
  'pages.users.roleEligibility.missing_permission':
    'Falta uma permissão exigida por esta função',
  'pages.users.roleEligibility.role_grants_roles_assign':
    'Funções que concedem atribuição de funções só podem ser gerenciadas pelo superadministrador',
  'pages.users.effectiveScope': 'Escopo efetivo',
  'pages.users.strategy': 'Estratégia',
  'pages.users.invite': 'Convidar Usuário',
  'pages.users.password': 'Senha',
  'pages.users.isAdmin': 'Administrador',
  'pages.users.normalUser': 'Normal',
  'pages.users.edit': 'Editar Usuário',
  'pages.users.updateSuccess': 'Usuário atualizado',
  'pages.users.updateFailed': 'Falha ao atualizar usuário',
  'pages.users.security': 'Segurança',
  'pages.users.securitySettings': 'Configurações de Segurança',
  'pages.users.securityUpdateSuccess': 'Configurações de segurança atualizadas',
  'pages.users.securityUpdateFailed':
    'Falha ao atualizar configurações de segurança',
  'pages.users.tfaEnforce': 'Exigir Autenticação em Dois Fatores',
  'pages.users.emailVerification': 'Exigir Verificação por E-mail',
  'pages.users.resetPassword': 'Redefinir Senha',
  'pages.users.resetPasswordTooltip':
    'Deixe em branco para manter a senha atual',
  'pages.users.confirmPassword': 'Confirmar Senha',
  'pages.users.passwordMismatch': 'As senhas não coincidem',
  'pages.users.passwordTooShort': 'A senha deve ter pelo menos 6 caracteres',
  'pages.users.forceLogout': 'Encerrar Sessão',
  'pages.users.forceLogoutSuccess': 'Sessão encerrada com sucesso',
  'pages.users.forceLogoutFailed': 'Falha ao encerrar sessão',
  'pages.users.batchEnable': 'Ativar em Lote',
  'pages.users.batchDisable': 'Desativar em Lote',
  'pages.users.batchForceLogout': 'Encerrar Sessões em Lote',
  'pages.users.batchEnableConfirm':
    'Tem certeza de que deseja ativar os usuários selecionados?',
  'pages.users.batchDisableConfirm':
    'Tem certeza de que deseja desativar os usuários selecionados?',
  'pages.users.batchForceLogoutConfirm':
    'Tem certeza de que deseja encerrar a sessão dos usuários selecionados?',
  'pages.users.batchEnableSuccess': '{count} usuário(s) ativado(s) com sucesso',
  'pages.users.batchEnableFailed': 'Falha ao ativar usuários',
  'pages.users.batchEnablePartialFailed':
    '{success} usuário(s) ativado(s) com sucesso, {failed} falharam',
  'pages.users.batchDisableSuccess':
    '{count} usuário(s) desativado(s) com sucesso',
  'pages.users.batchDisableFailed': 'Falha ao desativar usuários',
  'pages.users.batchDisablePartialFailed':
    '{success} usuário(s) desativado(s) com sucesso, {failed} falharam',
  'pages.users.batchForceLogoutSuccess':
    'Encerramento de sessões em lote realizado com sucesso',
  'pages.users.batchForceLogoutFailed':
    'Falha ao encerrar sessões dos usuários',
  'pages.dashboard.totalUsers': 'Usuários',
  'pages.dashboard.adminUsers': 'Admin',
  'pages.dashboard.normalUsers': 'Normal',
  'pages.dashboard.totalDevices': 'Dispositivos',
  'pages.dashboard.onlineDevices': 'Online',
  'pages.dashboard.offlineDevices': 'Offline',
  'pages.dashboard.todayConnections': 'Conexões',
  'pages.dashboard.successCount': 'Sucesso',
  'pages.dashboard.failureCount': 'Falha',
  'pages.dashboard.todayTransfers': 'Transferências',
  'pages.dashboard.uploadCount': 'Upload',
  'pages.dashboard.downloadCount': 'Download',
  'pages.dashboard.systemStatus': 'Status do Sistema',
  'pages.dashboard.uptime': 'Tempo de Atividade',
  'pages.dashboard.trendData': 'Tendências',
  'pages.dashboard.alarmTrend': 'Alarmes',
  'pages.dashboard.resourceCounts': 'Recursos',
  'pages.dashboard.addressBooks': 'Catálogos de Endereços',
  'pages.dashboard.groups': 'Grupos',
  'pages.dashboard.roles': 'Funções',
  'pages.dashboard.strategies': 'Estratégias',

  'pages.common.pleaseEnterName': 'Por favor, informe o nome',
  'pages.common.pleaseEnterId': 'Por favor, informe o ID',
  'pages.common.pleaseEnterTagName': 'Por favor, informe o nome da tag',
  'pages.common.pleaseEnterUsername': 'Por favor, informe o nome de usuário',
  'pages.common.pleaseEnterEmail': 'Por favor, informe o e-mail',
  'pages.common.pleaseEnterValidEmail': 'Por favor, informe um e-mail válido',
  'pages.common.pleaseEnterPassword': 'Por favor, informe a senha',
  'pages.common.pleaseEnterRoleName': 'Por favor, informe o nome da função',
  'pages.common.id': 'ID',
  'pages.dashboard.day': 'd',
  'pages.dashboard.hour': 'h',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': 'Memória',
  'pages.dashboard.disk': 'Disco',
  'pages.dashboard.connectionTrend': 'Conexões',
  'pages.dashboard.newUsersTrend': 'Novos Usuários',

  'pages.dashboard.7days': '7 Dias',
  'pages.dashboard.30days': '30 Dias',
  'pages.dashboard.90days': '90 Dias',
  'pages.dashboard.noData': 'Nenhum dado',
  'pages.smtp.title': 'Configuração SMTP',
  'pages.smtp.description':
    'Configure o servidor SMTP para envio de e-mails de notificação do sistema',
  'pages.smtp.host': 'Endereço do Servidor',
  'pages.smtp.hostPlaceholder': 'Informe o endereço do servidor SMTP',
  'pages.smtp.port': 'Porta',
  'pages.smtp.portPlaceholder': 'Informe o número da porta',
  'pages.smtp.secure': 'Usar SSL/TLS',
  'pages.smtp.secureHelp':
    'Ativa conexão segura (normalmente a porta 465 usa SSL e a 587 usa TLS)',
  'pages.smtp.user': 'Nome de Usuário',
  'pages.smtp.userPlaceholder': 'Informe o usuário de autenticação SMTP',
  'pages.smtp.password': 'Senha',
  'pages.smtp.passwordPlaceholder': 'Informe a senha de autenticação SMTP',
  'pages.smtp.from': 'E-mail do Remetente',
  'pages.smtp.fromPlaceholder': 'Informe o endereço de e-mail do remetente',
  'pages.smtp.enabled': 'Ativar Configuração',
  'pages.smtp.enabledHelp':
    'Quando ativada, esta configuração será utilizada para enviar e-mails do sistema',
  'pages.smtp.testConnection': 'Testar Conexão',
  'pages.smtp.testSuccess': 'Teste de conexão SMTP realizado com sucesso',
  'pages.smtp.testFailed': 'Falha no teste de conexão SMTP',
  'pages.smtp.saveSuccess': 'Configuração SMTP salva com sucesso',
  'pages.smtp.saveFailed': 'Falha ao salvar configuração SMTP',
  'pages.smtp.createdAt': 'Criado em',
  'pages.smtp.updatedAt': 'Atualizado em',
  'pages.addressBook.color': 'Cor',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Gerenciar Tags',
  'pages.addressBook.newTagName': 'Nome da Nova Tag',
  'pages.addressBook.peerUpdateFailed': 'Falha ao atualizar contato',
  'pages.addressBook.peerUpdated': 'Contato atualizado',
  'pages.addressBook.renameTag': 'Renomear Tag',
  'pages.addressBook.selectTags': 'Selecionar tags',
  'pages.addressBook.tagColorUpdateFailed': 'Falha ao atualizar a cor da tag',
  'pages.addressBook.tagRenameFailed': 'Falha ao renomear tag',
  'pages.addressBook.tagRenamed': 'Tag renomeada',
  'pages.addressBook.untagged': 'Sem Tag',
  'pages.addressBook.searchIdPlaceholder': 'Buscar por ID',
  'pages.addressBook.searchNamePlaceholder': 'Buscar por nome',
  'pages.addressBook.searchNotePlaceholder': 'Buscar por observação',
  'pages.common.cancel': 'Não',
  'pages.common.confirm': 'Sim',
  'pages.common.enterDescription': 'Informe uma descrição',
  'pages.common.rename': 'Renomear',
  'pages.common.save': 'Salvar',
  'pages.common.close': 'Fechar',
  'pages.common.back': 'Voltar',
  'pages.userGroups.enterName': 'Informe o nome do grupo',
  'pages.userGroups.searchNamePlaceholder': 'Buscar por nome',
  'pages.users.admin': 'Administrador',
  'pages.users.me': 'Eu',
  'pages.users.searchNamePlaceholder': 'Buscar por nome de usuário',
  'pages.users.searchEmailPlaceholder': 'Buscar por email',
  'pages.users.searchStrategyPlaceholder': 'Buscar por estratégia',
  'pages.users.searchUserGroupPlaceholder': 'Buscar por grupo de usuários',
  'pages.oidcProviders.list': 'Provedores OIDC',
  'pages.oidcProviders.sort': 'Ordenar',
  'pages.oidcProviders.name': 'Nome do Provedor',
  'pages.oidcProviders.type': 'Tipo',
  'pages.oidcProviders.issuer': 'URL do Emissor',
  'pages.oidcProviders.clientId': 'ID do Cliente',
  'pages.oidcProviders.clientSecret': 'Segredo do Cliente',
  'pages.oidcProviders.scope': 'Escopo',
  'pages.oidcProviders.authorizationEndpoint': 'Endpoint de Autorização',
  'pages.oidcProviders.tokenEndpoint': 'Endpoint de Token',
  'pages.oidcProviders.userinfoEndpoint': 'Endpoint de Informações do Usuário',
  'pages.oidcProviders.jwksUri': 'URI JWKS',
  'pages.oidcProviders.enabled': 'Ativado',
  'pages.oidcProviders.endpointConfig': 'Configuração dos Endpoints',
  'pages.oidcProviders.create': 'Criar Provedor',
  'pages.oidcProviders.edit': 'Editar Provedor',
  'pages.oidcProviders.test': 'Testar',
  'pages.oidcProviders.testResult': 'Resultado do Teste de Conexão',
  'pages.oidcProviders.discoveredEndpoints': 'Endpoints Descobertos',
  'pages.oidcProviders.enterName': 'Informe o nome do provedor',
  'pages.oidcProviders.enterIssuer': 'Informe a URL do emissor',
  'pages.oidcProviders.enterClientId': 'Informe o ID do cliente',
  'pages.oidcProviders.enterClientSecret': 'Informe o segredo do cliente',
  'pages.oidcProviders.enterEndpoint': 'Descoberto automaticamente se vazio',
  'pages.oidcProviders.createSuccess': 'Provedor OIDC criado',
  'pages.oidcProviders.createFailed': 'Falha ao criar provedor OIDC',
  'pages.oidcProviders.updateSuccess': 'Provedor OIDC atualizado',
  'pages.oidcProviders.updateFailed': 'Falha ao atualizar provedor OIDC',
  'pages.oidcProviders.deleteSuccess': 'Provedor OIDC removido',
  'pages.oidcProviders.deleteFailed': 'Falha ao remover provedor OIDC',
  'pages.oidcProviders.deleteConfirm':
    'Tem certeza de que deseja remover este provedor?',
  'pages.oidcProviders.enableSuccess': 'Provedor OIDC ativado',
  'pages.oidcProviders.enableFailed': 'Falha ao ativar provedor OIDC',
  'pages.oidcProviders.disableSuccess': 'Provedor OIDC desativado',
  'pages.oidcProviders.disableFailed': 'Falha ao desativar provedor OIDC',
  'pages.oidcProviders.enableConfirm':
    'Tem certeza de que deseja ativar este provedor?',
  'pages.oidcProviders.disableConfirm':
    'Tem certeza de que deseja desativar este provedor?',
  'pages.oidcProviders.testFailed': 'Falha ao testar conexão OIDC',
  'pages.oidcProviders.sortFailed': 'Falha ao atualizar ordem dos provedores',
  'pages.oidcProviders.preset': 'Modelo de Provedor',
  'pages.oidcProviders.presetPlaceholder':
    'Selecione um provedor integrado ou personalizado',
  'pages.oidcProviders.custom': 'Personalizado',
  'pages.oidcProviders.icon': 'Ícone (SVG)',
  'pages.oidcProviders.uploadSvg': 'Carregar SVG',
  'pages.oidcProviders.clearIcon': 'Limpar',
  'pages.oidcProviders.svgTooLarge': 'Arquivo SVG muito grande (máx. 100KB)',
  'pages.oidcProviders.invalidSvg': 'Conteúdo SVG inválido',
  'pages.oidcProviders.fetchDetailFailed':
    'Falha ao obter detalhes do provedor',
  'pages.user.center.tab.basic': 'Informações Básicas',
  'pages.user.center.tab.security': 'Segurança',
  'pages.user.center.basicInfo.displayName': 'Nome de Exibição',
  'pages.user.center.basicInfo.displayNamePlaceholder':
    'Digite o nome de exibição',
  'pages.user.center.basicInfo.name': 'Nome de Usuário',
  'pages.user.center.basicInfo.email': 'E-mail',
  'pages.user.center.basicInfo.note': 'Observação',
  'pages.user.center.basicInfo.updateSuccess': 'Perfil atualizado com sucesso',
  'pages.user.center.basicInfo.updateFailed': 'Falha ao atualizar perfil',
  'pages.user.center.avatar.hint':
    'Suporta JPG, PNG e WebP, tamanho máximo de 2 MB, será redimensionado para 256x256',
  'pages.user.center.avatar.upload': 'Enviar Avatar',
  'pages.user.center.avatar.delete': 'Remover Avatar',
  'pages.user.center.avatar.deleteConfirm':
    'Tem certeza de que deseja remover seu avatar?',
  'pages.user.center.avatar.uploadSuccess': 'Avatar enviado com sucesso',
  'pages.user.center.avatar.uploadFailed': 'Falha ao enviar avatar',
  'pages.user.center.avatar.deleteSuccess': 'Avatar removido com sucesso',
  'pages.user.center.avatar.deleteFailed': 'Falha ao remover avatar',
  'pages.user.center.avatar.fileTooLarge':
    'O tamanho do arquivo não pode exceder 2 MB',
  'pages.user.center.avatar.invalidFormat':
    'Apenas os formatos JPG, PNG e WebP são suportados',
  'pages.user.center.security.title': 'Configurações de Segurança',
  'pages.user.center.security.2faStatus': 'Status do 2FA',
  'pages.user.center.security.enabled': 'Ativado',
  'pages.user.center.security.disabled': 'Desativado',
  'pages.user.center.security.enable2FA': 'Ativar 2FA',
  'pages.user.center.security.disable2FA': 'Desativar 2FA',
  'pages.user.center.security.setup2FA':
    'Configurar Autenticação em Dois Fatores',
  'pages.user.center.security.setupFailed': 'Falha ao configurar 2FA',
  'pages.user.center.security.scanQRCode':
    'Escaneie o código QR com seu aplicativo autenticador e depois informe o código de verificação abaixo.',
  'pages.user.center.security.secretKey': 'Chave Secreta',
  'pages.user.center.security.verificationCode': 'Código de Verificação',
  'pages.user.center.security.enterCode': 'Informe o código de verificação',
  'pages.user.center.security.verifyAndEnable': 'Verificar e Ativar',
  'pages.user.center.security.enableSuccess': '2FA ativado com sucesso',
  'pages.user.center.security.enableFailed': 'Falha ao ativar 2FA',
  'pages.user.center.security.currentCode': 'Código de Verificação Atual',
  'pages.user.center.security.confirmDisable': 'Confirmar Desativação',
  'pages.user.center.security.disableSuccess': '2FA desativado com sucesso',
  'pages.user.center.security.disableFailed': 'Falha ao desativar 2FA',
  'pages.user.center.security.password': 'Senha de Login',
  'pages.user.center.security.passwordSet': 'Configurada',
  'pages.user.center.security.passwordNotSet': 'Não Configurada',
  'pages.user.center.security.changePassword': 'Alterar Senha',
  'pages.user.center.security.currentPassword': 'Senha Atual',
  'pages.user.center.security.enterCurrentPassword': 'Informe a senha atual',
  'pages.user.center.security.newPassword': 'Nova Senha',
  'pages.user.center.security.enterNewPassword':
    'Informe a nova senha (mínimo de 6 caracteres)',
  'pages.user.center.security.confirmNewPassword': 'Confirmar Nova Senha',
  'pages.user.center.security.confirmNewPasswordPlaceholder':
    'Informe novamente a nova senha',
  'pages.user.center.security.passwordMinLength':
    'A senha deve ter pelo menos 6 caracteres',
  'pages.user.center.security.passwordMismatch': 'As duas senhas não coincidem',
  'pages.user.center.security.changePasswordSuccess':
    'Senha alterada com sucesso',
  'pages.user.center.security.changePasswordFailed': 'Falha ao alterar senha',
  'pages.user.center.security.thirdPartyUser':
    'Usuários autenticados por terceiros não podem alterar a senha',
  'pages.user.center.security.noPasswordUser':
    'Nenhuma senha configurada para esta conta',
  'pages.user.center.security.passkey.title': 'Gerenciamento de Passkey',
  'pages.user.center.security.passkey.register': 'Registrar Passkey',
  'pages.user.center.security.passkey.registerSuccess':
    'Passkey registrado com sucesso',
  'pages.user.center.security.passkey.registerFailed':
    'Falha ao registrar Passkey',
  'pages.user.center.security.passkey.deleteSuccess':
    'Passkey excluído com sucesso',
  'pages.user.center.security.passkey.deleteFailed': 'Falha ao excluir Passkey',
  'pages.user.center.security.passkey.deleteConfirm':
    'Tem certeza de que deseja excluir este Passkey?',
  'pages.user.center.security.passkey.name': 'Nome',
  'pages.user.center.security.passkey.namePlaceholder': 'ex: MacBook Touch ID',
  'pages.user.center.security.passkey.namePasskey': 'Nomeie seu Passkey',
  'pages.user.center.security.passkey.deviceType': 'Tipo de Dispositivo',
  'pages.user.center.security.passkey.multiDevice': 'Multi-dispositivo',
  'pages.user.center.security.passkey.singleDevice': 'Dispositivo único',
  'pages.user.center.security.passkey.createdAt': 'Criado em',
  'pages.user.center.security.passkey.noCredentials':
    'Nenhum Passkey registrado',
  'pages.user.center.security.passkey.tfaStatus': 'TFA por Passkey',
  'pages.user.center.security.passkey.tfaEnabled': 'TFA por Passkey ativado',
  'pages.user.center.security.passkey.tfaDisabled':
    'TFA por Passkey desativado',
  'pages.user.center.security.passkey.tfaToggleFailed':
    'Falha ao alternar TFA por Passkey',
  'pages.user.center.security.sessions.title': 'Sessões de Login',
  'pages.user.center.security.sessions.device': 'Dispositivo',
  'pages.user.center.security.sessions.type': 'Tipo',
  'pages.user.center.security.sessions.browser': 'Navegador',
  'pages.user.center.security.sessions.client': 'Cliente',
  'pages.user.center.security.sessions.os': 'SO',
  'pages.user.center.security.sessions.createdAt': 'Criado em',
  'pages.user.center.security.sessions.expiresAt': 'Expira em',
  'pages.user.center.security.sessions.current': 'Atual',
  'pages.user.center.security.sessions.revoke': 'Revogar',
  'pages.user.center.security.sessions.revokeConfirm':
    'Tem certeza de que deseja revogar esta sessão?',
  'pages.user.center.security.sessions.revokeSuccess':
    'Sessão revogada com sucesso',
  'pages.user.center.security.sessions.revokeFailed': 'Falha ao revogar sessão',
  'pages.user.center.security.sessions.cannotRevokeCurrent':
    'Não é possível revogar a sessão atual',
  'pages.user.center.security.sessions.noSessions': 'Nenhuma sessão ativa',
  'pages.ldap.title': 'Configuração LDAP',
  'pages.ldap.description':
    'Configure a autenticação LDAP/Active Directory. Quando ativado, os usuários serão autenticados automaticamente via LDAP.',
  'pages.ldap.urls': 'URLs do Servidor',
  'pages.ldap.urlsRequired': 'Informe pelo menos uma URL de servidor LDAP',
  'pages.ldap.urlPlaceholder': 'ex.: ldaps://ad.exemplo.com:636',
  'pages.ldap.addUrl': 'Adicionar URL do Servidor',
  'pages.ldap.bindDN': 'DN de Vinculação',
  'pages.ldap.bindDNRequired': 'Informe o DN da conta de serviço',
  'pages.ldap.bindDNPlaceholder':
    'ex.: CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Senha de Vinculação',
  'pages.ldap.bindCredentialsRequired': 'Informe a senha da conta de serviço',
  'pages.ldap.bindCredentialsPlaceholder':
    'Informe a senha da conta de serviço',
  'pages.ldap.searchBase': 'DN Base de Pesquisa',
  'pages.ldap.searchBaseRequired': 'Informe o DN base de pesquisa',
  'pages.ldap.searchBasePlaceholder': 'ex.: DC=example,DC=com',
  'pages.ldap.searchFilter': 'Filtro de Pesquisa',
  'pages.ldap.searchFilterRequired': 'Informe o filtro de pesquisa',
  'pages.ldap.searchFilterHelp':
    'Use {{username}} como marcador do nome de usuário. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': 'ex.: (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Atributos de Pesquisa',
  'pages.ldap.searchAttributePlaceholder':
    'ex.: dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Adicionar Atributo',
  'pages.ldap.groupSearchBase': 'DN Base de Pesquisa de Grupos',
  'pages.ldap.groupSearchBasePlaceholder': 'ex.: OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Filtro de Pesquisa de Grupo',
  'pages.ldap.groupSearchFilterHelp':
    'Use {{dn}} como marcador do DN do usuário. Ex.: (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'ex.: (member={{dn}})',
  'pages.ldap.adminGroups': 'Grupos Administradores',
  'pages.ldap.adminGroupsHelp':
    'Usuários desses grupos LDAP serão mapeados como administradores (comparação sem diferenciar maiúsculas e minúsculas)',
  'pages.ldap.adminGroupPlaceholder':
    'ex.: CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Adicionar Grupo Administrador',
  'pages.ldap.tlsOptions': 'Opções TLS',
  'pages.ldap.tlsCa': 'Certificado CA (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Certificado do Cliente (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Chave Privada do Cliente (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'Nome do Servidor SNI',
  'pages.ldap.tlsServernamePlaceholder':
    'Indicação do Nome do Servidor para TLS',
  'pages.ldap.enabled': 'Ativar Autenticação LDAP',
  'pages.ldap.enabledHelp':
    'Quando ativado, os usuários serão autenticados no servidor LDAP. Usuários já vinculados ao LDAP sempre utilizarão autenticação LDAP independentemente desta configuração.',
  'pages.ldap.testConnection': 'Testar Conexão',
  'pages.ldap.testSuccess': 'Teste de conexão LDAP realizado com sucesso',
  'pages.ldap.testFailed': 'Falha no teste de conexão LDAP',
  'pages.ldap.saveSuccess': 'Configuração LDAP salva com sucesso',
  'pages.ldap.saveFailed': 'Falha ao salvar configuração LDAP',
  'pages.ldap.createdAt': 'Criado em',
  'pages.ldap.updatedAt': 'Atualizado em',
  'pages.nexus.repoRequired': 'Interação com Repositório Necessária',
  'pages.nexus.repoRequiredDesc':
    'Você precisa dar Star, Fork ou Watch no repositório databk/rustdesk-console no GitHub antes de gerar clientes personalizados. Pode levar até 5 minutos para o cache ser atualizado.',
  'pages.nexus.goToRepo': 'Ir para o Repositório GitHub',
  'pages.nexus.buildList': 'Histórico de Builds',
  'pages.nexus.createBuild': 'Criar Novo Cliente',
  'pages.nexus.createBuildTitle': 'Criar Cliente Personalizado',
  'pages.nexus.customConfig': 'Configuração Personalizada',
  'pages.nexus.serverConfig': 'Configuração do Servidor',
  'pages.nexus.password': 'Senha',
  'pages.nexus.passwordPlaceholder': 'Informe a senha',
  'pages.nexus.salt': 'Salt',
  'pages.nexus.saltPlaceholder': 'Informe o salt',
  'pages.nexus.connType': 'Tipo de Conexão',
  'pages.nexus.disableInstallation': 'Desativar Instalação',
  'pages.nexus.disableSettings': 'Desativar Configurações',
  'pages.nexus.disableAccount': 'Desativar Conta',
  'pages.nexus.disableAb': 'Desativar AB',
  'pages.nexus.disableTcpListen': 'Desativar TCP Listen',
  'pages.nexus.rendezvousServer': 'Servidor de ID',
  'pages.nexus.relayServer': 'Servidor Relay',
  'pages.nexus.key': 'Chave',
  'pages.nexus.apiServer': 'Servidor API',
  'pages.nexus.overrideSettings': 'Sobrescrever Configurações',
  'pages.nexus.defaultSettings': 'Configurações Padrão',
  'pages.nexus.deleteBuildConfirm':
    'Tem certeza de que deseja excluir este registro de build?',
  'pages.nexus.deleteSuccess': 'Registro de build excluído',
  'pages.nexus.deleteFailed': 'Falha ao excluir registro de build',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.os': 'Sistema Operacional',
  'pages.nexus.arch': 'Arquitetura',
  'pages.nexus.appName': 'Nome do Aplicativo',
  'pages.nexus.appNamePlaceholder': 'ex.: my-rustdesk',
  'pages.nexus.appNameHint': 'Apenas letras em inglês são permitidas',
  'pages.nexus.bindSuccess': 'Conta Github vinculada com sucesso',
  'pages.nexus.bindFailed': 'Falha ao vincular conta Github',
  'pages.nexus.createLoginFailed': 'Falha ao criar sessão de login',
  'pages.nexus.unbindConfirm': 'Desvincular Conta Github',
  'pages.nexus.unbindConfirmContent':
    'Tem certeza de que deseja desvincular sua conta Github? Você precisará vincular novamente para gerar clientes personalizados.',
  'pages.nexus.unbindSuccess': 'Conta Github desvinculada',
  'pages.nexus.unbindFailed': 'Falha ao desvincular conta Github',
  'pages.nexus.tokenExpired': 'Token Github Expirado',
  'pages.nexus.tokenExpiredDesc':
    'Seu token Github para {username} expirou. Por favor, vincule novamente sua conta.',
  'pages.nexus.rebind': 'Vincular Novamente Conta Github',
  'pages.nexus.bindTitle': 'Vincular Conta Github',
  'pages.nexus.bindDesc':
    'Você precisa vincular sua conta GitHub para gerar clientes personalizados. Clique no botão abaixo para autorizar via GitHub.',
  'pages.nexus.bindGithub': 'Autorizar com GitHub',
  'pages.nexus.unbind': 'Desvincular',
  'pages.nexus.repoInteractionRequired':
    'Por favor, dê Star, Fork ou Watch no repositório databk/rustdesk-console no GitHub primeiro. Pode levar até 5 minutos para o cache ser atualizado.',
  'pages.nexus.buildAlreadyRunning': 'Você já tem um build em andamento',
  'pages.nexus.generateFailed': 'Falha ao enviar solicitação de build',
  'pages.nexus.retryBuild': 'Tentar Novamente',
  'pages.nexus.retryBuildFailed': 'Falha ao tentar build novamente',
  'pages.nexus.downloadFailed': 'Falha ao baixar cliente personalizado',
  'pages.nexus.buildAgain': 'Buildar Novamente',
  'pages.nexus.status': 'Status',
  'pages.nexus.statusPending': 'Build Pendente',
  'pages.nexus.statusBuilding': 'Buildando',
  'pages.nexus.statusCompleted': 'Build Concluído',
  'pages.nexus.statusFailed': 'Build Falhou',
  'pages.nexus.statusCancelled': 'Build Cancelado',
  'pages.nexus.bindWhyLogin':
    'A autenticação GitHub nos ajuda a verificar que você é um usuário real, prevenindo abuso automatizado dos recursos de build. Solicitamos apenas seus dados públicos — sem acesso aos seus repositórios, dados pessoais ou quaisquer outras permissões.',
  'pages.nexus.repoWhyInteract':
    'Sou um estudante do ensino médio desenvolvendo este projeto no tempo livre. Seu Star, Fork ou Watch significa muito para mim — não apenas me mantém motivado, mas também ajuda com meus aplicativos para a faculdade. É a única coisa que peço em troca. Muito obrigado pelo seu apoio!',
};
